module.exports = __webpack_public_path__ + "img/test_four4.90dfa238.png";